// extracted by mini-css-extract-plugin
module.exports = {"headerActions":"SupplierWiseCurrencyPurchaseTransactionPage_headerActions__3ZMTN","inputContainer":"SupplierWiseCurrencyPurchaseTransactionPage_inputContainer__2hy2_"};